import {
  LanguageCode,
  CurrencyCode,
  RemainStatus,
  OrderStatus
} from '@linktivity/triplabo-shinkansen';
import { OrderableTimeRange } from './types';

export { CurrencyCode, RemainStatus, OrderStatus };

export const LANGUAGE_CODE_MAP = {
  en: LanguageCode.EnUs,
  ja: LanguageCode.JaJp,
  zh: LanguageCode.ZhHans,
  zt: LanguageCode.ZhHant,
  ko: LanguageCode.KoKr
};

export type LanguageCodeType = keyof typeof LANGUAGE_CODE_MAP;

export const CURRENCY_CODE_MAP = {
  en: CurrencyCode.Usd,
  ja: CurrencyCode.Jpy,
  ko: CurrencyCode.Krw,
  zh: CurrencyCode.Cny,
  zt: CurrencyCode.Twd
} as const;

export const SHINKANSEN_THEME_COLOR = '#0393f4';

export const FROM_STATION_CODE = 'fromStationCode';
export const TO_STATION_CODE = 'toStationCode';
export const DEPART_DATE = 'departDate';
export const DEPART_TIME_FROM = 'departTimeFrom';
export const DEPART_TIME_TO = 'departTimeTo';
export const DIA_CODE = 'diaCode';
export const SEAT_CLASS_ID = 'seatClassId';

export const DEPARTURE = 'departure';
export const ARRIVAL = 'arrival';

export const DEFAULT_DEPART_DATE_OFFSET = 4;
export const DEFAULT_DEPART_DATE = (() => {
  const date = new Date();
  date.setDate(date.getDate() + DEFAULT_DEPART_DATE_OFFSET);
  return date;
})();
export const DEFAULT_DEPART_TIME_FROM = '06:00';
export const DEFAULT_DEPART_TIME_TO = '08:59';

export const ORDERABLE_TIME_RANGES: readonly OrderableTimeRange[] = [
  {
    from: '06:00',
    to: '08:59'
  },
  {
    from: '09:00',
    to: '11:59'
  },
  {
    from: '12:00',
    to: '14:59'
  },
  {
    from: '15:00',
    to: '17:59'
  },
  {
    from: '18:00',
    to: '20:59'
  },
  {
    from: '21:00',
    to: '23:59'
  }
] as const;

export const TOKYO_STATION_CODE = 'SMEX010';
export const NEW_YOKOHAMA_STATION_CODE = 'SMEX030';
// TODO: these should be fetched from the server
export const OSAKA_STATION_CODE = 'SMEX170';
export const KYOTO_STATION_CODE = 'SMEX160';
export const NAGOYA_STATION_CODE = 'SMEX130';
export const FUKUOKA_STATION_CODE = 'SMEX350';
export const KUMAMOTO_STATION_CODE = 'SMEX410';
export const DEFAULT_FROM_STATION_CODE = TOKYO_STATION_CODE;
export const DEFAULT_TO_STATION_CODE = NEW_YOKOHAMA_STATION_CODE;

export const unitMaxQuantity = 99;
export const unitMinQuantity = 0;

export const DEFAULT_SEAT_PREFERENCE_CODE = 'NONE';

export const SHINKANSEN_FAQ_DATA = [
  {
    question: 'views.shinkansen.faq.q1',
    answer: 'views.shinkansen.faq.a1'
  },
  {
    question: 'views.shinkansen.faq.q2',
    answer: 'views.shinkansen.faq.a2'
  },
  {
    question: 'views.shinkansen.faq.q3',
    answer: 'views.shinkansen.faq.a3'
  }
];
